import actions from "./actions";

const {
    FETCH_SUBSTITUTE,
    FETCH_SUBSTITUTES,
    RESET_SUBSTITUTE,
    FETCH_SUBSTITUTE_ROUTINE,
    RESET_SUBSTITUTE_ROUTINE,
    FETCH_SUBSTITUTE_REPORTS,
    FETCH_SUBSTITUTE_TEACHER_PERIODS
} = actions;

const initState = {
    substitutes: {
        data: []
    },
    substituteTeacherPeriods: {
        data: []
    },
    substituteReports: {
        data: []
    },
    substitute: { _id: null },
    substituteRoutine: {
        substituteRoutineInfo: {_id: null},
        availableTeachers: []
    }
};

const SubstituteReducer = (state = initState, action) => {
    const { type, data } = action;
    switch (type) {
        case FETCH_SUBSTITUTES:
            return {
                ...state,
                substitutes: data
            };
        case FETCH_SUBSTITUTE_REPORTS:
            return {
                ...state,
                substituteReports: data
            };
        case FETCH_SUBSTITUTE_TEACHER_PERIODS:
            return {
                ...state,
                substituteTeacherPeriods: data
            };
        case RESET_SUBSTITUTE:
            return {
                ...state,
                substitute: initState.substitute
            };
        case FETCH_SUBSTITUTE:
            return {
                ...state,
                substitute: data
            };
        case FETCH_SUBSTITUTE_ROUTINE:
            return {
                ...state,
                substituteRoutine: data
            };
        case RESET_SUBSTITUTE_ROUTINE:
            return {
                ...state,
                substituteRoutine: {
                    substituteRoutineInfo: { _id: null },
                    availableTeachers: []
                }
            };
        default:
            return state;
    }
};

export default SubstituteReducer;
